import React, { useState, useEffect, createContext, useContext } from 'react';
import { useCookies } from 'react-cookie';
import { localStorageKeys } from 'constants/localStorage';
import { initialState } from './initialState';
import { URLS } from 'constants/urls';

const GlobalFiltersContext = createContext(initialState);
GlobalFiltersContext.displayName = 'GlobalFiltersContext';

const FiltersProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [cookie, setCookie] = useCookies();

  useEffect(() => {
    const updatedHeaderFilters = { ...state.headerFilters };

    const stored = localStorage.getItem(localStorageKeys.headerFiltersContext);
    const storedHeaderFilters = stored ? JSON.parse(stored)?.headerFilters || {} : {};

    Object.keys(updatedHeaderFilters).forEach(filterName => {
      const cookieData = cookie[filterName];
      const storedData = storedHeaderFilters[filterName];
      if (filterName === 'systems') {
        // não sobrescrever systems aqui
        return;
      }
      // Se ambos existirem e os IDs forem iguais
      if (cookieData?.id && storedData?.id && String(cookieData.id) === String(storedData.id)) {
        const cookieNameEmpty = !cookieData.name || cookieData.name.trim() === '';
        const storedNameValid = storedData.name && storedData.name.trim() !== '';

        if (cookieNameEmpty && storedNameValid) {
          // Atualiza o cookie com o name do storage
          setCookie(filterName, { id: cookieData.id, name: storedData.name }, { path: '/', domain: URLS.cookieDomain });
        }
      }

      // Atualiza o contexto com o que está no cookie
      if (cookie[filterName]?.id) {
        updatedHeaderFilters[filterName] = {
          id: String(cookie[filterName].id),
          name: String(cookie[filterName].name),
        };
      } else {
        updatedHeaderFilters[filterName] = false;
      }
    });

    const newState = {
      ...state,
      headerFilters: updatedHeaderFilters,
    };

    setState(newState);
    // Dependia só de `[]` (rodava 1x, no mount do app inteiro — ANTES do login). Login troca
    // o cookie `companies` (client-side, sem reload), mas esse efeito nunca reagia: o contexto
    // ficava com headerFilters.companies=false pro resto da sessão SPA, e qualquer componente
    // que dependesse de um companyId válido logo após o login (ex.: Dashboard) recebia
    // undefined. Um F5 sempre "resolvia" porque remonta este provider com o cookie JÁ setado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cookie]);

  useEffect(() => {
    // Salva o contexto no localStorage
    localStorage.setItem(localStorageKeys.headerFiltersContext, JSON.stringify(state));
  }, [state]);

  return (
    <GlobalFiltersContext.Provider
      value={{
        headerFiltersContext: state,
        setFiltersContext: setState,
      }}
    >
      {children}
    </GlobalFiltersContext.Provider>
  );
};

export const useHeaderFilters = () => useContext(GlobalFiltersContext);

export { GlobalFiltersContext as FiltersContext, FiltersProvider as HeaderFiltersProvider, initialState };
